import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "review-list" }
const _hoisted_2 = { class: "review-section" }
const _hoisted_3 = { class: "review-card" }
const _hoisted_4 = { class: "review-row review-row--title-bottom" }
const _hoisted_5 = { class: "review-row review-row--title-bottom" }
const _hoisted_6 = { class: "review-row review-row--title-bottom" }
const _hoisted_7 = { class: "review-row review-row--title-bottom" }
const _hoisted_8 = { class: "review-section" }
const _hoisted_9 = { class: "review-card" }
const _hoisted_10 = { class: "review-row" }
const _hoisted_11 = { class: "review-row" }
const _hoisted_12 = { class: "review-row" }
const _hoisted_13 = { class: "review-row" }
const _hoisted_14 = { class: "review-row" }
const _hoisted_15 = { class: "review-section" }
const _hoisted_16 = { class: "review-card" }
const _hoisted_17 = { class: "review-row" }
const _hoisted_18 = { class: "review-row" }
const _hoisted_19 = { class: "review-row" }
const _hoisted_20 = { class: "review-row" }
const _hoisted_21 = { class: "review-row" }
const _hoisted_22 = { class: "review-section" }
const _hoisted_23 = { class: "review-card" }
const _hoisted_24 = { class: "review-row review-row--title-bottom" }
const _hoisted_25 = { class: "review-file" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "review-file-name" }
const _hoisted_28 = { class: "review-row review-row--title-bottom" }
const _hoisted_29 = { class: "review-file" }
const _hoisted_30 = ["src", "alt"]
const _hoisted_31 = { class: "review-file-name" }
const _hoisted_32 = { class: "review-section" }
const _hoisted_33 = { class: "review-card" }
const _hoisted_34 = { class: "review-row review-row--title-bottom" }
const _hoisted_35 = { class: "review-file" }
const _hoisted_36 = ["src", "alt"]
const _hoisted_37 = { class: "review-file-name" }
const _hoisted_38 = { class: "confirm-card mb-6" }
const _hoisted_39 = {
  key: 0,
  class: "field-error"
}
const _hoisted_40 = {
  key: 1,
  class: "field-error"
}
const _hoisted_41 = {
  key: 0,
  class: "review-section"
}
const _hoisted_42 = { class: "review-card" }
const _hoisted_43 = { class: "review-row review-row--title-bottom" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  key: 1,
  class: "review-section"
}

import { computed, onBeforeUnmount, ref, watch } from "vue";
import PaymentBlock from "@/shared/components/ui/flow/PaymentBlock.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewForm',
  props: {
    stripe_publishable_key: { default: "" },
    stripe_account: { default: "" },
    membership_package: { default: "" },
    membership_package_data: { default: null },
    billing_interval: { default: "monthly" },
    basicInfo: { default: () => ({
      business_name: "",
      business_type: "",
      service_category: "",
      tax_id: "",
    }) },
    contactPerson: { default: () => ({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      phone_alt: "",
      phone1: "",
      phone2: "",
    }) },
    address: { default: () => ({
      line_1: "",
      line_2: "",
      city: "",
      state: "",
      zip: "",
      lat: null,
      lng: null,
      country_code: null,
      country: null,
    }) },
    documents: { default: () => ({
      id_front: null,
      id_back: null,
    }) },
    selfie: { default: null },
    agree_terms: { type: Boolean, default: false },
    certify_information: { type: Boolean, default: false },
    errors: { default: () => ({}) }
  },
  emits: ["update:agree_terms", "update:certify_information", "click:terms"],
  setup(__props: any, { expose: __expose }) {

const defaultStripePublishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY || "";

const props = __props;

const resolvedStripePublishableKey = computed(
  () => props.stripe_publishable_key || defaultStripePublishableKey,
);
const resolvedStripeAccount = computed(() => props.stripe_account || "");

const resolvedContactPerson = computed(() => {
  return (
    props.contactPerson || {
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      phone_alt: "",
      phone1: "",
      phone2: "",
    }
  );
});

const hasContactPerson = computed(() => {
  const c = resolvedContactPerson.value;
  return Boolean(
    (c.first_name || "").trim() ||
      (c.last_name || "").trim() ||
      (c.email || "").trim() ||
      (c.phone || "").trim() ||
      (c.phone_alt || "").trim() ||
      (c.phone1 || "").trim() ||
      (c.phone2 || "").trim(),
  );
});

const idFrontPreviewUrl = ref<string | null>(null);
const idBackPreviewUrl = ref<string | null>(null);
const selfiePreviewUrl = ref<string | null>(null);

function isImageFile(file: File | null | undefined) {
  const type = file?.type || "";
  return Boolean(type && type.startsWith("image/"));
}

function revokeUrl(target: { value: string | null }) {
  if (target.value) {
    URL.revokeObjectURL(target.value);
    target.value = null;
  }
}

watch(
  () => props.documents?.id_front,
  (file) => {
    revokeUrl(idFrontPreviewUrl);
    if (file && isImageFile(file)) idFrontPreviewUrl.value = URL.createObjectURL(file);
  },
  { immediate: true },
);

watch(
  () => props.documents?.id_back,
  (file) => {
    revokeUrl(idBackPreviewUrl);
    if (file && isImageFile(file)) idBackPreviewUrl.value = URL.createObjectURL(file);
  },
  { immediate: true },
);

watch(
  () => props.selfie,
  (file) => {
    revokeUrl(selfiePreviewUrl);
    if (file && isImageFile(file)) selfiePreviewUrl.value = URL.createObjectURL(file);
  },
  { immediate: true },
);

onBeforeUnmount(() => {
  revokeUrl(idFrontPreviewUrl);
  revokeUrl(idBackPreviewUrl);
  revokeUrl(selfiePreviewUrl);
});

const amountDue = computed(() => {
  const data: any = props.membership_package_data;
  if (!data) return null;
  const key = props.billing_interval === "yearly" ? "price_yearly" : "price_monthly";
  const amount = Number(data?.[key]);
  return Number.isFinite(amount) ? amount : null;
});

const shouldShowPayment = computed(() => Number(amountDue.value) > 0);

const paymentBlockRef = ref();



__expose({
  paymentBlockRef
});

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "review-section-title" }, "Basic Info", -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Business Name", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.basicInfo.business_name || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[4] || (_cache[4] = _createElementVNode("span", null, "Business Type", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.basicInfo.business_type || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(__props.basicInfo.business_type === 'freelancer' ? 'Social Security Number' : 'EIN / Tax ID'), 1),
            _createElementVNode("strong", null, _toDisplayString(__props.basicInfo.tax_id || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Service Category", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.basicInfo.service_category || '-'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (hasContactPerson.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "review-section-title" }, "Contact Person", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", null, "First Name", -1)),
                  _createElementVNode("strong", null, _toDisplayString(resolvedContactPerson.value.first_name || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[8] || (_cache[8] = _createElementVNode("span", null, "Last Name", -1)),
                  _createElementVNode("strong", null, _toDisplayString(resolvedContactPerson.value.last_name || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", null, "Email", -1)),
                  _createElementVNode("strong", null, _toDisplayString(resolvedContactPerson.value.email || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", null, "Phone", -1)),
                  _createElementVNode("strong", null, _toDisplayString(resolvedContactPerson.value.phone || resolvedContactPerson.value.phone1 || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", null, "Alt. Phone", -1)),
                  _createElementVNode("strong", null, _toDisplayString(resolvedContactPerson.value.phone_alt || resolvedContactPerson.value.phone2 || '-'), 1)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "review-section-title" }, "Address", -1)),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _cache[13] || (_cache[13] = _createElementVNode("span", null, "Address Line 1", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.address.line_1 || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[14] || (_cache[14] = _createElementVNode("span", null, "Address Line 2", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.address.line_2 || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _cache[15] || (_cache[15] = _createElementVNode("span", null, "City", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.address.city || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _cache[16] || (_cache[16] = _createElementVNode("span", null, "State", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.address.state || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[17] || (_cache[17] = _createElementVNode("span", null, "ZIP", -1)),
            _createElementVNode("strong", null, _toDisplayString(__props.address.zip || '-'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _cache[21] || (_cache[21] = _createElementVNode("div", { class: "review-section-title" }, "Documents", -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[19] || (_cache[19] = _createElementVNode("strong", null, "ID Proof (Front)", -1)),
            _createElementVNode("div", _hoisted_25, [
              (idFrontPreviewUrl.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "review-file-thumb",
                    src: idFrontPreviewUrl.value,
                    alt: __props.documents.id_front?.name || 'ID Proof (Front)'
                  }, null, 8, _hoisted_26))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_27, _toDisplayString(__props.documents.id_front?.name || "-"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[20] || (_cache[20] = _createElementVNode("strong", null, "ID Proof (Back)", -1)),
            _createElementVNode("div", _hoisted_29, [
              (idBackPreviewUrl.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "review-file-thumb",
                    src: idBackPreviewUrl.value,
                    alt: __props.documents.id_back?.name || 'ID Proof (Back)'
                  }, null, 8, _hoisted_30))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_31, _toDisplayString(__props.documents.id_back?.name || "-"), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "review-section-title" }, "Selfie", -1)),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              (selfiePreviewUrl.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "review-file-thumb",
                    src: selfiePreviewUrl.value,
                    alt: __props.selfie?.name || 'Selfie'
                  }, null, 8, _hoisted_36))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_37, _toDisplayString(__props.selfie?.name || "-"), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_38, [
      _createVNode(_component_v_checkbox, {
        "model-value": __props.agree_terms,
        color: "success",
        "hide-details": "",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:agree_terms', Boolean($event))))
      }, {
        label: _withCtx(() => [
          _createElementVNode("span", null, [
            _cache[23] || (_cache[23] = _createTextVNode(" I agree to the ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "terms-link",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('click:terms')), ["stop"]))
            }, " terms and conditions "),
            _cache[24] || (_cache[24] = _createTextVNode(". ", -1))
          ])
        ]),
        _: 1
      }, 8, ["model-value"]),
      (__props.errors.agree_terms)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(__props.errors.agree_terms), 1))
        : _createCommentVNode("", true),
      _createVNode(_component_v_checkbox, {
        "model-value": __props.certify_information,
        color: "success",
        label: "I certify that the information provided is accurate.",
        "hide-details": "",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:certify_information', Boolean($event))))
      }, null, 8, ["model-value"]),
      (__props.errors.certify_information)
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(__props.errors.certify_information), 1))
        : _createCommentVNode("", true)
    ]),
    (__props.membership_package || shouldShowPayment.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "review-section-title" }, "Membership Package", -1)),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _cache[25] || (_cache[25] = _createElementVNode("span", null, "Selected Package", -1)),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(__props.membership_package || '-'), 1),
                (shouldShowPayment.value)
                  ? (_openBlock(), _createElementBlock("strong", _hoisted_44, " $" + _toDisplayString(__props.membership_package_data[__props.billing_interval === 'yearly' ? 'price_yearly' : 'price_monthly']) + " / " + _toDisplayString(__props.billing_interval === 'yearly' ? 'yearly' : 'monthly'), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (shouldShowPayment.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _renderSlot(_ctx.$slots, "payment", {}, () => [
            _createVNode(PaymentBlock, {
              ref_key: "paymentBlockRef",
              ref: paymentBlockRef,
              publishableKey: resolvedStripePublishableKey.value,
              stripeAccount: resolvedStripeAccount.value,
              amount: amountDue.value
            }, null, 8, ["publishableKey", "stripeAccount", "amount"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})